import React, {Fragment} from "react"

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";



const faqContent = [
    {
        title: "¿Qué incluye el soporte IT?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "a",
    },
    {
        title: "¿Qué hacen las empresas de soluciones IT?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "b",
    },
    {
        title: "¿Cuáles son ejemplos de soluciones IT?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "c",
    },
    {
        title: "¿Qué significa IT en el departamento de IT?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "d",
    },
    {
        title: "¿Qué significa IT en el departamento de IT?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "e",
    },
    {
        title: "¿Qué es una empresa de soluciones de software?",
        desc: "Iniciar proactivamente vortales corporativos a través de relaciones físico-digitales. Visualizar dinámicamente paradigmas de vanguardia a través de relaciones centradas en el cliente. Reutilizar globalmente compatibilidad retroactiva.",
        expanded: "f",
    },
]

const FAQ = () => {

    
    return (
        <Fragment>
            <Accordion className="accordion accordion-one" preExpanded={["a"]}
                allowZeroExpanded>
                {faqContent.map((val, i)=>(
                    <AccordionItem className="accordion-item" key={i} uuid={val.expanded}>
                    <AccordionItemHeading className="accordion-header">
                        <AccordionItemButton>
                            {val.title}
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel
                        className="accordion-collapse collapse show">
                        <div className="accordion-body">
                            <p>{val.desc}</p>
                        </div>
                    </AccordionItemPanel>
                </AccordionItem>
                ))}
            </Accordion>
        </Fragment>
    )
}

export default FAQ







